import { css } from 'styled-components';

export const haloRingBase = css`
  &::before {
    content: '';
    position: absolute;
    inset: -1px;
    border: 1px solid;
    border-color: ${({ theme }) => theme.colors.gridV2HaloRingBorder};
    transform: scale(1.5);
    opacity: 0;
    transition:
      transform 0.2s ease,
      opacity 0.2s ease,
      border-color 0.2s ease;
  }
`;

export const haloRingHover = css`
  transform: scale(1);
  opacity: 1;
`;

export const haloRingPressed = css`
  border-color: ${({ theme }) => theme.colors.gridV2HaloRingBorderPressed};
`;
